/* BBB cart drawer + reward bar. No libraries. */
(function(){
  var C=window.BBB_CART||{}, root=window.Shopify&&Shopify.routes&&Shopify.routes.root||'/';
  function money(c){var a=(c/100).toFixed(2), f=C.moneyFormat||'£{{amount}}';
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(c/100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,a.replace('.',',')).replace(/\{\{\s*\w+\s*\}\}/,a);}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]});}
  function j(url,opt){return fetch(root.replace(/\/$/,'')+url,Object.assign({headers:{'Content-Type':'application/json',Accept:'application/json'}},opt)).then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d;});});}
  function rewards(total){
    var t=C.threshold||6000;
    document.querySelectorAll('[data-bbb-reward]').forEach(function(el){
      var done=total>=t, m=el.querySelector('.bbb-rw-msg');
      el.classList.toggle('is-done',done);
      m.textContent= done? C.msgDone : (total>0? C.msgAway.replace('[amount]',money(t-total)) : C.msgIntro);
      el.querySelector('.bbb-rw-fill').style.width=Math.min(100,total/t*100)+'%';
    });
  }
  function preDiscount(c){ if(typeof c.original_total_price==='number')return c.original_total_price; return (c.items||[]).reduce(function(a,i){return a+(i.original_line_price||0);},0); }
  window.BBBCart_preDiscount=preDiscount; window.BBBCart_rewards=rewards;
  var D=function(){return document.getElementById('bbb-cd');};
  function render(cart){
    rewards(preDiscount(cart)); updateCount(cart.item_count);
    var d=D(); if(!d)return;
    var box=d.querySelector('.bbb-cd-items');
    box.innerHTML= cart.items.length? cart.items.map(function(it){
      var img=it.image? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):'';
      return '<div class="bbb-cd-line" data-key="'+esc(it.key)+'">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+
      '<div class="bbb-cd-info"><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
      (it.variant_title&&it.variant_title!=='Default Title'?'<div class="bbb-cd-var">'+esc(it.variant_title)+'</div>':'')+
      (it.selling_plan_allocation?'<div class="bbb-cd-var">'+esc(it.selling_plan_allocation.selling_plan.name)+'</div>':'')+
      '<div class="bbb-cd-row"><div class="bbb-cd-qty"><button type="button" aria-label="Decrease" data-q="'+(it.quantity-1)+'">&minus;</button><span>'+it.quantity+'</span><button type="button" aria-label="Increase" data-q="'+(it.quantity+1)+'">+</button></div>'+
      '<strong>'+money(it.final_line_price)+'</strong></div><button type="button" class="bbb-cd-rm" data-q="0">Remove</button></div></div>';
    }).join('') : '<div class="bbb-cd-empty">Your basket is empty.</div>';
    d.querySelector('[data-bbb-sub]').textContent=money(cart.total_price);
    d.querySelector('[data-bbb-del]').textContent=C.delivery;
    d.querySelector('.bbb-cd-foot').style.display=cart.items.length?'':'none';
  }
  function updateCount(n){document.querySelectorAll('[data-cart-count], .cart-count, .header-cart__count, [data-bind="itemCount"]').forEach(function(e){e.textContent=n;});}
  function refresh(){return j('/cart.js').then(function(c){render(c);return c;});}
  function open(){var d=D();if(!d)return;document.documentElement.classList.add('bbb-cd-open');d.setAttribute('aria-hidden','false');refresh();}
  function close(){var d=D();if(!d)return;document.documentElement.classList.remove('bbb-cd-open');d.setAttribute('aria-hidden','true');}
  function add(form){
    var fd=new FormData(form), btn=form.querySelector('[type=submit]');
    if(btn)btn.classList.add('bbb-cd-busy');
    return fetch(root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}})
      .then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d;});})
      .then(function(){ if(window.$&&$.fancybox)try{$.fancybox.close();}catch(e){} open(); document.dispatchEvent(new CustomEvent('bbb:cart:added'));})
      .catch(function(e){alert((e&&(e.description||e.message))||'Sorry, could not add to basket.');})
      .finally(function(){if(btn)btn.classList.remove('bbb-cd-busy');});
  }
  window.BBBCart={open:open,close:close,add:add,refresh:refresh};
  document.addEventListener('submit',function(e){
    var f=e.target; if(!C.drawer||!f.matches||!f.matches('form[action*="/cart/add"]'))return;
    if(e.submitter&&e.submitter.name==='checkout')return;
    e.preventDefault(); e.stopImmediatePropagation(); add(f);
  },true);
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-bbb-close]')){close();return;}
    var q=t.closest('#bbb-cd [data-q]');
    if(q){var line=q.closest('[data-key]');line.classList.add('bbb-cd-busy');
      j('/cart/change.js',{method:'POST',body:JSON.stringify({id:line.dataset.key,quantity:+q.dataset.q})}).then(render).catch(function(){refresh();});return;}
    if(!C.drawer)return;
    var a=t.closest('a[href$="/cart"], a[href="/cart"], [data-ajax-cart-trigger]');
    if(a&&!a.closest('#bbb-cd')&&!/\/cart\/?$/.test(location.pathname)){e.preventDefault();e.stopImmediatePropagation();open();}
  },true);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  // cart page: Flex reloads / uses ajax; keep bar in sync
  document.addEventListener('DOMContentLoaded',function(){
    if(document.querySelector('[data-bbb-reward]')){var el=document.querySelector('[data-bbb-reward][data-initial]');if(el)rewards(+el.dataset.initial);refresh();}
    if(/\/cart\/?$/.test(location.pathname)){var o=window.fetch;window.fetch=function(){return o.apply(this,arguments).then(function(r){var u=String(arguments[0]&&arguments[0].url||arguments[0]);if(/\/cart\/(change|update|add)/.test(u))setTimeout(refresh,150);return r;});};}
  });
})();
